import apiClient from "../common";
import { prefetchApiCsrfToken } from "../common";
import {
  parseSimulationsListPayload,
  type SavedSimulationRow,
  type SimulationStatusCode,
} from "./simulationsList";

const JSON_API_MEDIA = "application/vnd.api+json";

export type ManualSimulationStatusCode = Extract<
  SimulationStatusCode,
  "failed" | "archived"
>;

export async function apiPatchSimulationStatus(
  id: string,
  status: ManualSimulationStatusCode
): Promise<SavedSimulationRow> {
  await prefetchApiCsrfToken();
  const body = {
    data: {
      type: "simulations",
      id,
      attributes: { status },
    },
  };
  const res = await apiClient.patch(`simulations/${id}/`, body, {
    headers: {
      Accept: JSON_API_MEDIA,
      "Content-Type": JSON_API_MEDIA,
    },
  });
  const rows = parseSimulationsListPayload(res.data);
  const updated = rows.find((r) => r.id === id);
  if (updated) {
    return updated;
  }
  return {
    id,
    simulation_name: "",
    status,
    created_at: "",
    executed_at: null,
    closed_at: null,
    simulated_purchase_orders: [],
  };
}
